import { Typography } from "antd";
import type { OnboardingStepData } from "features/onboarding/data/types";
import React from "react";
import "./StepContent.css";

const StepContent: React.FC<{ step?: OnboardingStepData }> = ({ step }) => {
  const renderMedia = () => {
    if (!step) return null;
    if (step.videoUrl) {
      return (
        <video
          width="100%"
          height="auto"
          controls
        >
          <source
            src={step.videoUrl}
            type="video/mp4"
          />
        </video>
      );
    }
    if (step.imageUrl) {
      return (
        <img
          alt=""
          src={step.imageUrl}
          style={{ maxWidth: "100%" }}
        />
      );
    }

    return null;
  };

  return (
    <div className="onboarding-step-content">
      <Typography.Title
        level={3}
        style={{ margin: "0" }}
      >
        {step?.title || ""}
      </Typography.Title>
      <Typography.Text style={{ margin: "12px 0 0 0" }}>
        {step?.description || ""}
      </Typography.Text>
      {renderMedia()}
    </div>
  );
};

export default StepContent;
